(function () {
    'use strict';
    var m = angular.module('profiles');
    m.factory('emailMetaInfoLogic', ["widgetPolling", "emailDao", "metaInfoLogicCore", "modals", "modulesManager", "entityTypes", "fileDao", "mainQueueTroubleshootingHelper", "recheckParams", "$rootScope", "limitedArrayConverter", "submitForAnalysisParams", "suspiciousReportParams", "troubleshooting", "sideMenuManager", "reportAsMisClassificationParams", "feature", "downloadDetectedEntity", function (widgetPolling, emailDao, metaInfoLogicCore, modals, modulesManager, entityTypes, fileDao, mainQueueTroubleshootingHelper, recheckParams, $rootScope, limitedArrayConverter, submitForAnalysisParams, suspiciousReportParams, troubleshooting, sideMenuManager, reportAsMisClassificationParams, feature, downloadDetectedEntity) {
        function recheckEmail(entityType, entityId) {
            return recheckParams.show('Do you want to recheck this email?', entityType).then(function (data) {
                return fileDao.recheck(entityType, entityId, data.selectApplications ? data.apps : undefined);
            }).then(function () {
                $rootScope.$broadcast('file-security-stack-reload');
            });
        }
        // function submitForAnalysis(entityType, entityId, entityData) {
        //     return submitForAnalysisParams.show('Submit email for analysis', 'email', entityType, entityId, {
        //         objectTypesData: widgetPolling.scope().objectTypes && widgetPolling.scope().objectTypes.data,
        //         entityData: entityData
        //     }).then(function (data) {
        //         return fileDao.shareForAnalysis(entityType, entityId, 'email', data);
        //     });
        // }
        function suspiciousReport(entityType, entityId, entityData) {
            return suspiciousReportParams.show('Report this email', entityType, entityId, {
                objectTypesData: widgetPolling.scope().objectTypes && widgetPolling.scope().objectTypes.data,
                entityData: entityData
            }).then(function (data) {
                return fileDao.suspiciousReport(entityType, entityId, data);
            });
        }
        $rootScope.$on('report-mis-classification', function (event, eventData) {
            reportAsMisClassificationParams.show('Mis-classification report', 'email').then(function (data) {
                reportAsMisClassificationParams.show('Thank you');
                var postData = {
                    classification: data.status,
                    confident: data.confident,
                    phishing: data.status,
                    entities: [eventData.entityId]
                };
                return fileDao.reportMisClassification(postData);
            });
        });
        return function ($scope, logic, reinit) {
            var id = widgetPolling.scope().id;
            var entityType = widgetPolling.scope().entityType;
            var downloadTestResponse = widgetPolling.scope().downloadTestResponse;
            var localEntityLabel = entityTypes.toLocal(entityType) || _(entityType.split('_')).last() || 'item';
            var coreOptions;
            var onActionUnsubscribe = widgetPolling.on('remediationActionPerformed', function () {
                logic.updateTick = 2000;
                logic.restoreUpdateTickAfter = moment().add(1, 'minutes');
                reinit();
            });
            if (logic.restoreUpdateTickAfter && logic.restoreUpdateTickAfter.isBefore(moment())) {
                logic.updateTick = logic.originalUpdateTick;
                logic.restoreUpdateTickAfter = null;
            }
            mainQueueTroubleshootingHelper.addTroubleshootingButton($scope.model.wrapper);
            $scope.isAvailableInfoWidget = false;
            coreOptions = {
                advanced: logic.advanced || true,
                whiteList: logic.whiteList,
                blackList: logic.blackList,
                autoWidget: true,
                ordering: 'widgetViewOrder',
                entityType: 'email',
                extendEntityInfo: logic.extendEntityInfo,
                whitelistEntityInfo: logic.whitelistEntityInfo,
                retrieve: function () {
                    return emailDao.retrieve(id).after(function (response) {
                        $scope.isAvailableInfoWidget = true;
                        $scope.isDeleted = response.data.is_deleted_message;
                        widgetPolling.scope().isDeleted = $scope.isDeleted;
                        if (logic.subjectTitle !== false) {
                            $scope.model.wrapper.title = response.data[logic.subjectField || 'Subject'];
                        }
                        // encryption_status for echoworx
                        if (response.data && response.data.encryption_status && widgetPolling.scope().entityType === 'office365_emails_email') {
                            coreOptions.buttons.push({
                                label: 'Encryption status',
                                'class': 'btn btn-blue',
                                onClick: function () {
                                    modals.widget({
                                        panel: {
                                            type: 'info',
                                            logic: {
                                                name: 'encryptionStatusLogic',
                                                entityType: 'office365_emails_email',
                                                entityId: id,
                                                updateTick: null
                                            },
                                            bodyStyle: { height: '415px' },
                                            class: 'light',
                                            size: 'medium',
                                            wrapper: {
                                                type: 'widget-panel',
                                                title: 'Email Encryption status',
                                                class: 'avanan white-body overflow-auto'
                                            },
                                            pair: { class: 'default-scan-details' }
                                        }
                                    });
                                }
                            });
                        }
                    });
                },
                mtaEmail: function () {
                    return fileDao.entityInfo('mta_email', id);
                },
                buttons: []
            };
            var warningMsg = 'Viewing an email\'s body or headers will be recorded in the audit log. Please note that ' + 'you are viewing it at your own risk as it might infringe your local privacy regulations.';
            function copyToClipboard(content) {
                var tempText = document.createElement('textarea');
                document.body.appendChild(tempText);
                tempText.value = content;
                tempText.select();
                document.execCommand('copy');
                document.body.removeChild(tempText);
            }
            function viewEmailHeader(id) {
                return emailDao.retrieveHeaderRawForMT(id).then(function (response) {
                    var emailHeaderRaw = response.data.headers;
                    return modals.widget({
                        panel: {
                            type: 'info',
                            'wrapper': {
                                'type': 'widget-panel',
                                'title': 'Email headers',
                                'class': 'avanan white-body overflow-auto max-height-500'
                            },
                            lines: [{
                                    text: emailHeaderRaw,
                                    class: 'email-header'
                                }]
                        },
                        addCloseX: 'true',
                        actionButtons: [{
                                label: 'Copy to clipboard',
                                click: function () {
                                    copyToClipboard(emailHeaderRaw);
                                }
                            }]
                    }, 'lg');
                }, function () {
                    var noDataMsg = 'Headers are unavailable';
                    var alertMessage = noDataMsg;
                    if ($scope.isDeleted) {
                        alertMessage = 'Email is already deleted and headers are unavailable';
                    }
                    modals.alert(alertMessage, { title: noDataMsg });
                });
            }
            function viewEmailBody(id) {
                return emailDao.retrieveBodyForMT(id).then(function (response) {
                    var isHtml = _(response.data).findKey(function (row) {
                        return row.key === 'ContentType' && _(row.value).isArray() && row.value[0] === 'HTML';
                    });
                    var widgetConfig = {
                        panel: {
                            type: 'meta-info',
                            'wrapper': {
                                'type': 'widget-panel',
                                'title': 'Email Body',
                                'class': 'avanan white-body overflow-auto max-height-500'
                            },
                            data: _(response.data).map(function (row) {
                                return {
                                    key: row.key,
                                    value: limitedArrayConverter(row.value, {
                                        expanded: 10000,
                                        collapseRest: true,
                                        isHtml: row.key === 'Content' ? isHtml : undefined
                                    })
                                };
                            }),
                            'pair': { 'class': 'email-meta-data' }
                        },
                        addCloseX: 'true'
                    };
                    return modals.widget(widgetConfig, 'lg');
                }, function () {
                    var alertMessage = 'Body is unavailable';
                    if ($scope.isDeleted) {
                        alertMessage = 'Email is already deleted and body is unavailable';
                    }
                    modals.alert(alertMessage, { title: 'Body is unavailable' });
                });
            }
            $scope.$watch('isAvailableInfoWidget', function (newVal, oldVal) {
                if (!oldVal && newVal) {
                    coreOptions.buttons = [];
                    if (feature.enableEntityRecheckButton && troubleshooting.entityDebugEnabled()) {
                        coreOptions.buttons.push({
                            label: 'Recheck',
                            'class': 'btn btn-blue',
                            onClick: function () {
                                return recheckEmail(entityTypes.toBackend(modulesManager.currentModule(), 'email'), id);
                            },
                            advanced: false
                        });
                    }
                    coreOptions.buttons.push({
                        label: 'Show headers from raw email',
                        'class': 'btn btn-blue',
                        onClick: function () {
                            var noConfirmViewEmailHeader = window.localStorage.getItem('view-email-header-no-confirm');
                            if (noConfirmViewEmailHeader) {
                                return viewEmailHeader(id);
                            }
                            return modals.confirm({
                                title: 'Notice',
                                message: warningMsg,
                                okText: 'Ok',
                                remember: 'Don\'t show this message again'
                            }).then(function (data) {
                                if (data.remember) {
                                    window.localStorage.setItem('view-email-header-no-confirm', true);
                                }
                                return viewEmailHeader(id);
                            });
                        }
                    });
                    var downloadTest = downloadTestResponse.data;
                    if (sideMenuManager.currentUser().view_private_data) {
                        if (feature.enableViewEmailBody) {
                            coreOptions.buttons.push({
                                label: 'Show body from raw email',
                                'class': 'btn btn-blue',
                                advanced: false,
                                onClick: function () {
                                    var noConfirmViewEmail = window.localStorage.getItem('view-email-body-no-confirm');
                                    if (noConfirmViewEmail) {
                                        return viewEmailBody(id);
                                    }
                                    return modals.confirm({
                                        title: 'Notice',
                                        message: warningMsg,
                                        okText: 'Ok',
                                        remember: 'Don\'t show this message again'
                                    }).then(function (data) {
                                        if (data.remember) {
                                            window.localStorage.setItem('view-email-body-no-confirm', true);
                                        }
                                        return viewEmailBody(id);
                                    });
                                }
                            });
                        }
                        if (downloadTest.success && feature.enableDownloadEntity) {
                            coreOptions.buttons.push({
                                label: 'Download this ' + localEntityLabel,
                                'class': 'btn btn-blue',
                                onClick: function () {
                                    downloadDetectedEntity.download(entityType, id);
                                },
                                advanced: false
                            });
                        } else {
                            console.log('Not allowed download this.');
                        }
                    }
                    if (downloadTest.success && feature.enableDownloadEntity && troubleshooting.entityDebugEnabled() && localEntityLabel === 'email') {
                        coreOptions.buttons.push({
                            label: 'Download original ' + localEntityLabel,
                            'class': 'btn btn-blue',
                            onClick: function () {
                                downloadDetectedEntity.download(entityType, id, true);
                            },
                            advanced: false
                        });
                    }
                    // if (troubleshooting.entityDebugEnabled() || feature.checkpointTheme) {
                    //     coreOptions.buttons.push({
                    //         label: 'Submit for analysis',
                    //         'class': 'btn btn-blue',
                    //         onClick: function () {
                    //             return submitForAnalysis(entityTypes.toBackend(modulesManager.currentModule(), 'email'), id);
                    //         },
                    //         advanced: true
                    //     });
                    // }
                    if (troubleshooting.entityDebugEnabled()) {
                        coreOptions.buttons.push({
                            label: 'Report this email',
                            'class': 'btn btn-blue',
                            onClick: function () {
                                return suspiciousReport(entityTypes.toBackend(modulesManager.currentModule(), 'email'), id, $scope.model.entityData);
                            },
                            advanced: false
                        });
                        coreOptions.buttons.push({
                            label: 'Email-Preview',
                            'class': 'btn btn-blue',
                            onClick: function () {
                                window.open('https://ap-avanan.avanan.net/admin/en_redirect/to?entity_id=' + id + '&reqtype=preview');
                            },
                            advanced: false
                        });
                    }
                }
            });
            var coreDestroy = metaInfoLogicCore($scope, logic, coreOptions);
            return function () {
                coreDestroy();
                onActionUnsubscribe();
            };
        };
    }]);
}());